import React, { useEffect, useRef } from "react";
import { usePollsContext } from "../../context/PollsContext";
import PollList from "../../components/Polls/PollList";
import { CPreloader } from "../../components/UI";
import "./style.scss";

export default () => {
    const {
        isLoading,
        defaultPolls,
        unreadPolls,
        answeredPolls,
        onReadPoll,
        readCurrentPollIds,
        onUpdateReadPolls,
        readPollIds,
    } = usePollsContext();
    const onReadPollsRef = useRef(onUpdateReadPolls);

    useEffect(() => {
        onReadPollsRef.current = onUpdateReadPolls;
    }, [onUpdateReadPolls]);

    useEffect(() => {
        return () => {
            if (onReadPollsRef.current) {
                onReadPollsRef.current();
            }
        }
    }, []);

    const isEmpty = !unreadPolls.length && !answeredPolls.length && !defaultPolls.length;

    return (
        <div className={'polls-container'}>
            <div className={'polls-container-main'}>
                {isLoading && isEmpty
                    ? <CPreloader />
                    : <PollList
                        defaultPolls={defaultPolls}
                        unreadPolls={unreadPolls}
                        answeredPolls={answeredPolls}
                        isEmpty={isEmpty}
                        onReadPoll={onReadPoll}
                        readCurrentPollIds={readCurrentPollIds}
                        readPollIds={readPollIds}
                    />
                }
            </div>
        </div>
    );
}
